// The Y-axis within Settings — `surfaces/settings.md` line 9's first shape.
//
// Present on every section rather than only on the home, so all eight are one
// click apart from wherever the operator currently is. That is what makes the
// four sections `areas.js` has no X-axis entry for genuinely reachable, which
// is the Definition of Done item this whole arrangement exists to satisfy.
//
// It is a `<nav>` with its own accessible name because the page already has
// two: the shell's Y-axis ("Primary") and its X-axis ("Section"). Three
// unlabelled navs on one page is three identical landmarks for anyone
// navigating by them.
import React from "react";
import { NavLink } from "react-router-dom";

import { pathFor, visibleSections } from "./sections";

export default function SectionIndex({ user }) {
  const sections = visibleSections(user);

  return (
    <nav className="set-index" aria-label="Settings sections">
      <ul className="set-index-list">
        {sections.map((s) => (
          <li key={s.id}>
            <NavLink
              to={pathFor(s)}
              end={!s.tab}
              className={({ isActive }) =>
                isActive ? "set-index-item on" : "set-index-item"
              }
            >
              <span className="set-index-label">{s.label}</span>
              <span className="set-index-blurb dim">{s.blurb}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
